import dayjs from "dayjs";
import { FilingReportItem } from "../../../api";
import { DEFAULT_SORT_RULES, type SortDirection, type SortRule, type SortableColumn } from "./types";

function getSortValue(row: FilingReportItem, column: SortableColumn): string | number {
  switch (column) {
    case "taskName":
      return row.taskName?.toLowerCase() ?? "";
    case "caseName":
      return row.caseName?.toLowerCase() ?? "";
    case "practiceArea":
      return row.practiceArea?.toLowerCase() ?? "";
    case "caseTeam":
      return row.caseTeam?.toLowerCase() ?? "";
    case "status":
      return row.status?.toLowerCase() ?? "";
    case "note":
      return row.note?.toLowerCase() ?? "";
    case "statusHistory":
      return row.statusUpdatedAt ? dayjs(row.statusUpdatedAt).valueOf() : 0;
    case "createdAt":
      return row.createdAt ? dayjs(row.createdAt).valueOf() : 0;
    case "dueDate":
      return row.dueDate ? dayjs(row.dueDate).valueOf() : Number.MAX_SAFE_INTEGER;
    default:
      return "";
  }
}

function compareSortValues(
  aValue: string | number,
  bValue: string | number,
  order: SortDirection
) {
  if (aValue < bValue) return order === "asc" ? -1 : 1;
  if (aValue > bValue) return order === "asc" ? 1 : -1;
  return 0;
}

function normalizeSortRules(rules: SortRule[] | undefined): SortRule[] {
  if (!rules?.length) return [...DEFAULT_SORT_RULES];
  const seen = new Set<SortableColumn>();
  const normalized: SortRule[] = [];
  rules.forEach((rule) => {
    if (seen.has(rule.column)) return;
    seen.add(rule.column);
    normalized.push(rule);
  });
  return normalized.length > 0 ? normalized : [...DEFAULT_SORT_RULES];
}

export function sortFilingRows(rows: FilingReportItem[], rules: SortRule[]): FilingReportItem[] {
  const sortRules = normalizeSortRules(rules);
  return [...rows].sort((a, b) => {
    for (const rule of sortRules) {
      const result = compareSortValues(
        getSortValue(a, rule.column),
        getSortValue(b, rule.column),
        rule.direction
      );
      if (result !== 0) return result;
    }
    return 0;
  });
}
